import { LoginService } from 'src/app/core/service/login.service';
import { Component, OnInit, inject, input } from '@angular/core';
import { links } from 'src/app/core/links';
import { RouterLink } from '@angular/router';
import { NgClass, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserService } from 'src/app/core/service/user.service';
import { NavigationMobilePanelComponent } from './navigation-mobile-panel/navigation-mobile-panel.component';
import { UserContextService } from 'src/app/core/service/user-context.service';
import { GlobalConstants } from 'src/app/core/global-constants';
import { ProfileSettingsModalComponent } from '../profile-settings-modal/profile-settings-modal.component';
import { UserModel } from 'src/app/core/models/user.model';
import { NotificationComponent } from '../notification/notification.component';

@Component({
    selector: 'lgfg-header-mobile',
    templateUrl: './header-mobile.component.html',
    styleUrls: ['./header-mobile.component.scss'],
    imports: [RouterLink, NavigationMobilePanelComponent, NgStyle, FormsModule, NgClass, NotificationComponent]
})
export class HeaderMobileComponent implements OnInit {
    private context = inject(UserContextService);
    private loginService = inject(LoginService);
    private userService = inject(UserService);

    readonly profileSettingsModal = input<ProfileSettingsModalComponent>(undefined);

    public search: string;
    public links = links;
    public settingsOpen = false;
    public isMenuOpen = false;
    public isDarkTheme: boolean;
    public isTechSupport: boolean;
    public hasAccessToSubmitPayment: boolean;

    public user: UserModel;


    async ngOnInit(): Promise<void> {
        this.user = this.context.user.value;
        this.isDarkTheme = !this.context.user.value.isBlackTheme;
        this.isTechSupport = this.context.isTechSupport();
        this.hasAccessToSubmitPayment = this.context.isRep() || this.context.isAdmin() || this.context.isEA() ||
            this.context.isAccounting();
        this.setTheme();
        this.context.avatarChange.subscribe(() => {
            this.user = this.context.user.value;
        });
    }


    public async logout(): Promise<void> {
        await this.loginService.logout();
    }

    public openHangfire() {
        document.cookie = GlobalConstants.jwtSessionKey + "=" + sessionStorage.getItem(GlobalConstants.jwtSessionKey);
        window.location.href = links.hangfireDashboard;
    }

    public onLinkClick(): void {
        document.getElementById('mainMenu').click();
    }

    public async changeTheme() {
        this.setTheme();
        await this.userService.setUserTheme(this.context.user.value.id, !this.isDarkTheme);
    }

    public toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        window.scrollTo(0, -60);
    }

    private setTheme() {
        document.body.classList.add(!this.isDarkTheme ? 'dark-theme' : 'light-theme');
        document.body.classList.remove(!this.isDarkTheme ? 'light-theme' : 'dark-theme');
        this.context.setTheme(!this.isDarkTheme);
    }
}
